import React from 'react';

const DotsIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="#FC4066" viewBox="0 0 24 24" stroke="#FC4066">
    <path strokeLinecap="round" fill="#FC4066" strokeLinejoin="round" strokeWidth={2} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
  </svg>
);

export default DotsIcon;
